import type { TablePaginationConfig } from 'antd';
import { useEffect, useState } from 'react';

export const DEFAULT_PAGE_SIZE = 20;
const PAGE_SIZE_OPTIONS = [10, 20, 50];

// Numbered (offset) pagination for the admin tables: owns page/pageSize and the reset-on-filter
// behavior. `resetKey` is a stable serialization of the active filters/sort — page snaps back to 1
// whenever it changes. `buildPagination(total)` is called with the count from the loaded page, so
// the table never has to reference the query result before it exists.
export const useTablePagination = (resetKey: unknown) => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);

  // biome-ignore lint/correctness/useExhaustiveDependencies: keyed on serialized filters, not page.
  useEffect(() => {
    setPage(1);
  }, [resetKey]);

  const buildPagination = (total: number): TablePaginationConfig => ({
    current: page,
    pageSize,
    total,
    position: ['bottomCenter'],
    showSizeChanger: true,
    pageSizeOptions: PAGE_SIZE_OPTIONS,
    showTotal: (t, [from, to]) => `${from}-${to} of ${t}`,
    onChange: (nextPage, nextPageSize) => {
      setPage(nextPage);
      setPageSize(nextPageSize);
    },
  });

  return { page, pageSize, buildPagination };
};
